import { ArrowDownIcon, ArrowUpIcon } from '@mentimeter/ragnar-visuals';
import type { IconButtonProps } from '@mentimeter/ragnar-ui/icon-button';
import { IconButton } from '@mentimeter/ragnar-ui/icon-button';
import { Hotkey } from '../../../../shared/components/Hotkey';

interface NavigationButtonProps extends IconButtonProps {
  onClick: () => void;
  direction: 'up' | 'down';
}

export const NavigationButton = ({
  disabled,
  onClick,
  direction,
  ...props
}: NavigationButtonProps) => {
  return (
    <IconButton
      disabled={disabled}
      variant="tertiary"
      borderRadius="full"
      size="large"
      onClick={onClick}
      {...props}
    >
      {!disabled && (
        <Hotkey
          keyCode={direction === 'up' ? 'arrowup' : 'arrowdown'}
          action={onClick}
        />
      )}
      {direction === 'up' && <ArrowUpIcon size={3} color="inherit" />}
      {direction === 'down' && <ArrowDownIcon size={3} color="inherit" />}
    </IconButton>
  );
};
